import React from 'react';
import { TextField, Box, Typography } from '@mui/material';

// A text field with a live character counter that turns amber then red as the
// value approaches/exceeds the recommended length. `recommended` is the SEO
// sweet spot (e.g. 60 for titles, 155 for descriptions); `max` is a hard cap.
export default function CharCountField({
  label,
  value = '',
  onChange,
  onBlur,
  name,
  recommended,
  max,
  multiline = false,
  rows,
  placeholder,
  helperText,
  error,
}) {
  const len = (value || '').length;
  let color = 'text.secondary';
  if (recommended) {
    if (len > (max || recommended)) color = 'error.main';
    else if (len > recommended) color = 'warning.main';
    else color = 'success.main';
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
        {recommended ? (
          <Typography variant="caption" sx={{ color }}>
            {len}/{recommended}
          </Typography>
        ) : null}
      </Box>
      <TextField
        fullWidth
        size="small"
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        multiline={multiline}
        rows={rows}
        placeholder={placeholder}
        error={!!error}
        helperText={error || helperText}
        inputProps={max ? { maxLength: max } : undefined}
      />
    </Box>
  );
}
